import React, { useMemo } from "react";

import { compact } from "lodash";

import TeamLink from "~/nav/panels/Home/Links/TeamLink";
import EmptyState from "~/nav/panels/Home/Sections/EmptyState";

import type { TeamLink_info$key as TeamFragment } from "~/__generated__/TeamLink_info.graphql";

type TeamData = TeamFragment & { id: string; archived: boolean };

interface TeamsSectionProps {
	items: ReadonlyArray<TeamData | null>;
}

export default function TeamsSection({ items }: TeamsSectionProps): React.ReactElement {
	const teams = useMemo(() => compact(items).filter(t => !t.archived), [items]);
	return (
		<>
			{teams.length > 0 ? (
				teams.map(team => <TeamLink key={team.id} team={team} />)
			) : (
				<EmptyState emptyStateText="Create a team to start tracking goals" />
			)}
		</>
	);
}
